// ===========================================================================
// 別タブへ送るメッセージの基底クラス（型はこのディレクトリにだけ置く）
// ===========================================================================
// 送る側も受ける側も、素のオブジェクトではなく**このファイルのクラス**を使う。
//
//   ・トピック名と中身の形がクラスに揃う（送る側と受ける側で文字列を
//     書き分けていると、片方だけ変えたときに黙って届かなくなる）
//   ・受け取った値は parse() で検証してからクラスに戻す。別バージョンの
//     タブ（デプロイ直後の古いタブ）から来た形の崩れたデータを、受け口ごとに
//     防御しなくてよい
//
// 新しい種類を足すときは CrossTabMessage を継承したクラスをこのディレクトリに
// 1 ファイルで作り、static topic / static fromFields(data) を定義して
// そのファイルの末尾で register する。index.js にも足すこと。
// 運ぶのは cross-tab-channel.js（BroadcastChannel の単一チャンネル）。

const REGISTRY = new Map();

export class CrossTabMessage {
    /** サブクラスで定義する。チャンネル上の識別子 */
    static topic = null;

    // サブクラスは static fromFields(data) も定義する
    // （受信データから自分を作る。形が合わなければ null）。

    static register(MessageClass) {
        if (!MessageClass?.topic) throw new Error('CrossTabMessage: topic が無いクラスは登録できません');
        if (typeof MessageClass.fromFields !== 'function') {
            throw new Error(`CrossTabMessage: "${MessageClass.topic}" に fromFields がありません`);
        }
        if (REGISTRY.has(MessageClass.topic)) {
            throw new Error(`CrossTabMessage: topic "${MessageClass.topic}" は登録済みです`);
        }
        REGISTRY.set(MessageClass.topic, MessageClass);
    }

    /**
     * 受信した素のデータをクラスに戻す。知らない topic・形の崩れたデータは null。
     * @returns {CrossTabMessage|null}
     */
    static parse(data) {
        const MessageClass = data && typeof data === 'object' ? REGISTRY.get(data.topic) : null;
        return MessageClass ? MessageClass.fromFields(data) : null;
    }

    constructor({ siteId }) {
        if (new.target === CrossTabMessage) {
            throw new Error('CrossTabMessage は直接作らず、サブクラスを使ってください');
        }
        this.siteId = siteId;
    }

    get topic() {
        return this.constructor.topic;
    }

    /**
     * 送信用の素のデータ。
     * ⚠ インスタンスをそのまま postMessage しない。構造化複製でプロトタイプが
     *   落ちるうえ、topic（static）が運ばれない。
     */
    toData() {
        return { ...this, topic: this.topic };
    }
}
